interface Props {
  step: string;
  title: string;
  description: string;
}

export default function SectionHeader({ step, title, description }: Props) {
  return (
    <div className="section-header">
      <div className="section-header__step">{step}</div>
      <div>
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
}
